import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import api from "@/lib/api";

export default function RemindersBar() {
  const [data, setData] = useState({ items: [], enabled: true, schedule_days: [] });
  const load = () => api.get("/billing/reminders").then(r => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const toggle = async () => { const { data: d } = await api.put("/billing/reminders/settings", { enabled: !data.enabled }); toast.success(d.enabled ? "Relances automatiques activées" : "Relances automatiques désactivées"); load(); };
  const run = async () => { try { const { data: d } = await api.post("/billing/reminders/run"); toast.success(`${d.sent.length} relance(s) envoyée(s)`); load(); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } };
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 bg-ivory border border-black/10 rounded-rama-md p-4 mb-4 text-sm" data-testid="reminders-bar">
      <div className="flex items-center gap-3">
        <BellRing size={16} className="text-bordeaux-700" />
        <div>
          <div className="font-medium">Relances douces automatiques</div>
          <div className="text-xs text-ink-soft">J+{data.schedule_days.join(", J+")} après échéance, 3 rappels max, jamais pour les factures payées · {data.items.length} facture(s) relancée(s)</div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button data-testid="reminders-run" onClick={run} className="btn-ghost text-xs">Lancer maintenant</button>
        <button data-testid="reminders-toggle" onClick={toggle} className={`text-xs px-3 py-2 rounded-full border ${data.enabled ? "bg-anthracite text-ivory border-anthracite" : "bg-white border-black/15"}`}>{data.enabled ? "Activées" : "Désactivées"}</button>
      </div>
    </div>
  );
}
